import React from "react";
import { makeStyles, withStyles } from "@material-ui/core";
import { defineMessages } from "react-intl";
import CloseIcon from "@material-ui/icons/Close";
import { DialogTitle as MuiDialogTitle, DialogContent as MuiDialogContent, DialogActions as MuiDialogActions, IconButton } from "@material-ui/core";

export const labels = defineMessages({
    close: {
        id: "admin.work-order-details.close",
        defaultMessage: "Close",
        description: "Admin work order close text",
    },
    open: {
        id: "admin.work-order-details.open",
        defaultMessage: "Open",
        description: "Admin work order open",
    },
    noOptions: {
        id: "admin.work-order-details.no-options",
        defaultMessage: "No options",
        description: "Admin work order no options",
    },
});

export const messages = defineMessages({
    incompleteJobTitle: {
        id: "task-incomplete-form.header-title",
        defaultMessage: "Incomplete job",
        description: "Incomplete task form title",
    },
    currentDate: {
        id: "incomplete-dialog.current-date",
        defaultMessage: "Date: ",
        description: "Current date dialog title",
    },
    incompleteReason: {
        id: "incomplete-dialog.incomplete-reason",
        defaultMessage: "Incompletion Reason",
        description: "Reason placeholder text",
    },
    reason: {
        id: "incomplete-dialog.reason",
        defaultMessage: "Select Reason",
        description: "Reason placeholder text",
    },
    subReason: {
        id: "incomplete-dialog.sub-reason",
        defaultMessage: "Select Sub-reason",
        description: "Sub-reason placeholder text",
    },
    requestComments: {
        id: "incomplete-dialog.incomplete-comment-field",
        defaultMessage: "Add your comments here",
        description: "submit incomplete job comments",
    },
    additionalDetails: {
        id: "incomplete-dialog.additional-comment-field",
        defaultMessage: "Additional Details",
        description: "Additional Details",
    },
    selectStart: {
        id: "incomplete-dialog.select-start-datetime-caption",
        defaultMessage: "Start date \u0026 time",
        description: "Assign resource start datetime caption",
    },
    followUpIfapplicable: {
        id: "task-complete-form.follow-ups-section-title",
        defaultMessage: "Follow-ups (if applicable)",
        description: "Follow-ups section title",
    },
    addFollowUpTitle: {
        id: "wo-actions.follow-ups.title",
        defaultMessage: "Follow-Up",
        description: "Follow-ups popup title",
    },
});

export const useStyles = makeStyles((theme) => ({
    numberInput: {
        "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            display: "none",
        },
    },
    characterCount: {
        float: "right",
        marginTop: "-20px",
        marginRight: "15px",
        fontSize: "10px",
        color: "#999999",
    },
    paper: {
        borderRadius: "10px",
        top: 25,
        maxHeight: "calc(100% - 100px)",
    },

    addComment: {
        marginTop: "20px",
    },
    followupAddComment: {
        marginTop: "20px",
        paddingRight: "10px",
        paddingLeft: "10px",
    },
    cardPadding: {
        paddingRight: "20px",
        paddingLeft: "20px",
    },
    currentDate: {
        padding: "10px 0px 10px 0px",
    },
    followups: {
        padding: "0px 0px 10px 0px",
    },
    followupsheader: {
        color: "var(--text-medium)",
        fontFamily: "Arial",
        fontSize: "16px",
        padding: "0px 0px 10px 0px",
    },
    addfollowUp: {
        borderRadius: "4px",
        border: "1px solid #00549A",
    },
    button: {
        padding: "8px 0px 8px",
    },
    followupCard: {
        border: "1px solid #E1E1E1",
        marginTop: "20px",
        marginBottom: "20px",
        padding: "0px !important",
        borderRadius: "10px",
        paddingBottom: "20px !important",
    },
    followupCardHeader: {
        height: "30px",
        padding: "0px 16px 0px 20px",
        background: "#E1E1E1",
        borderRadius: "10px 10px 0px 0px",
        display: "flex",
        justifyContent: "space-between",
    },
    confirmDisabledButton: {
        backgroundColor: "var(--disabled-color)",
        padding: "0.5rem 2rem",
        borderRadius: "0.5rem",
        "&.Mui-disabled": {
            color: "var(--inactive-color)",
        },
    },
    confirmButton: {
        backgroundColor: "var(--blue-bell)",
        color: "var(--text-white)",
        padding: "0.5rem 2rem",
        borderRadius: "0.5rem",
        "&:hover": {
            backgroundColor: "var(--blue-bell)",
            color: "var(--text-white)",
        },
    },
}));

export const styles = (theme) => ({
    title: {
        margin: 0,
        borderTopRightRadius: "10px",
        borderTopLeftRadius: "10px",
        backgroundColor: "var(--blue-bell)",
        height: 54,
        padding: "16px 32px",

        fontFamily: "BellSlimBlack",
        fontStyle: "normal",
        fontWeight: "900",
        fontSize: "18px",
        lineHeight: "22px",
        letterSpacing: "0.0018em",

        color: "var(--text-white)",
    },
    closeButton: {
        position: "absolute",
        right: "22px",
        top: "4px",
        color: "var(--text-white)",
    },
    addfollowUp: {
        borderRadius: "4px",
        border: "1px solid #00549A",
    },
    button: {
        padding: "8px 0px 8px",
    },
});

export const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.title} {...other}>
            <div>{children}</div>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon title="Close Dialog" />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

export const DialogContent = withStyles((theme) => ({
    root: {
        padding: "16px 32px",
    },
}))(MuiDialogContent);

export const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: "8px 32px 16px 32px",
    },
}))(MuiDialogActions);
